<template lang="pug">
  layout-form(:value="value" form='document' @afterSave="afterSave")
  //- layout()
  //-   template(v-slot:content)



</template>

<script>
import Document from '@/models/Document';

export default {
  props: {
    document: Document,
  },

  data: () => ({
    value: new Document(),
    isNew: true,
  }),

  created() {
    if (this.document) {
      this.value = this.document;
      this.isNew = false;
    }
  },

  methods: {
    afterSave(value) {
      if (this.isNew) {
        // редирект на страницу редактирования (для нового документа)
        this.$router.replace({ name: 'docs.view.edit', params: { id: value.id } });
      }
    },
  },
};
</script>
